import { useCallback } from 'react';
import { pick } from 'ramda';
import { useDispatch } from 'react-redux';
import { useStartWindowSession } from 'server';
import { useAppSelector } from 'js/store/hooks';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';
import { userSetAttributesAction, userUnsetAttributesAction } from 'js/hooks/user/store/actions';

import { useGetSubscriptionActionTypes } from './useGetSubscriptionActionTypes';

export const useSuccessLoginAction = () => {
    const dispatch = useDispatch();
    const startWindowSession = useStartWindowSession();
    const subscriptionActionTypes = useGetSubscriptionActionTypes();
    const {
        sessionSubscriptionTags = '',
        sessionSubscriptionBalances = '',
        // 123 -- AgeVerificationStatus
        sessionSubscriptionRequestedPlayerData = '123'
    } = useAppSelector(pick([
        'sessionSubscriptionTags',
        'sessionSubscriptionBalances',
        'sessionSubscriptionRequestedPlayerData'
    ]));

    return useCallback(async (userParams: {
        authType: 'token' | 'credentials';
        userName: string;
    }, options?: { signal?: AbortSignal }) => {
        const windowSessionId = Math.floor(Math.random() * 100000000);

        dispatch(userUnsetAttributesAction('password'));
        dispatch(userSetAttributesAction({
            role: 'user',
            isLoggedIn: true,
            hasBeenLoggedIn: true,
            isSessionStarted: false,
            windowSessionId,
            ...userParams
        }));

        const subscriptionTags = sessionSubscriptionTags
            .split(',')
            .map(tag => tag.trim())
            .concat(['uam/hidden/playerRecentGames']);
        const subscriptionBalanceTypes = sessionSubscriptionBalances
            .split(',')
            .map(type => type.trim());
        const subscriptionRequestedPlayerData = sessionSubscriptionRequestedPlayerData
            .split(',')
            .map(type => type.trim());

        await startWindowSession({
            windowSessionId: windowSessionId.toString(),
            subscriptionTags,
            subscriptionActionTypes,
            subscriptionBalanceTypes,
            subscriptionRequestedPlayerData
        }, options);

        dispatch(userSetAttributesAction({ isSessionStarted: true }));

        publicEventsAPIService.trigger('auth:generic_login:success');
    }, [
        dispatch,
        sessionSubscriptionBalances,
        sessionSubscriptionRequestedPlayerData,
        sessionSubscriptionTags,
        startWindowSession,
        subscriptionActionTypes
    ]);
};
